export default __webpack_public_path__ + "static/media/Path1669-tata-neu@2x.008157be.png";